import { ANIMATION_DURATION, TRANSITION_DELAY } from '@/constants/register.contants'
import { TypewriterText } from '@/shared/components/Typewriter/TypewriterText'
import { Grow, Paper } from '@mui/material'
import React, { useRef } from 'react'

export const ConsentMessage: React.FC<ConsentMessageProps> = ({ onAnimationComplete }) => {
  const animationCompleteRef = useRef(false)

  const handleEntered = () => {
    if (!animationCompleteRef.current) {
      animationCompleteRef.current = true
      setTimeout(onAnimationComplete, TRANSITION_DELAY)
    }
  }

  return (
    <Grow in={true} timeout={ANIMATION_DURATION} onEntered={handleEntered}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 1,
          borderRadius: 4,
          borderColor: 'divider',
          borderStyle: 'solid',
        }}
      >
        <TypewriterText
          variant="body1"
          color="text.primary"
          text={`One final step before you become a fellow Explorer! Kindly read through and tick on the following statements to provide your acknowledgement:`}
          delay={5}
        />
      </Paper>
    </Grow>
  )
}
